// extracted by mini-css-extract-plugin
export default {"errorText":"ContractEditError_errorText__fDW6b"};